export default {
    "name": "InventoryBySkuAndStore",
    "kind": "HoudiniQuery",
    "hash": "2fe185c3c29162ed7439df784523466307b6d4dd2138af20b7e3390b1386d541",

    "raw": `query InventoryBySkuAndStore($sku: Int!, $storeId: Int!) {
  inventoryBySkuAndStore(sku: $sku, storeId: $storeId) {
    id
    vehicleId
    skuNumber
    inventoryType {
      vehicle
      id
    }
  }
}
`,

    "rootType": "Query",
    "stripVariables": [],

    "selection": {
        "fields": {
            "inventoryBySkuAndStore": {
                "type": "Inventory",
                "keyRaw": "inventoryBySkuAndStore(sku: $sku, storeId: $storeId)",

                "selection": {
                    "fields": {
                        "id": {
                            "type": "UInt",
                            "keyRaw": "id",
                            "visible": true
                        },

                        "vehicleId": {
                            "type": "UInt",
                            "keyRaw": "vehicleId",
                            "nullable": true,
                            "visible": true
                        },

                        "skuNumber": {
                            "type": "UInt",
                            "keyRaw": "skuNumber",
                            "visible": true
                        },

                        "inventoryType": {
                            "type": "InventoryType",
                            "keyRaw": "inventoryType",

                            "selection": {
                                "fields": {
                                    "vehicle": {
                                        "type": "Boolean",
                                        "keyRaw": "vehicle",
                                        "visible": true
                                    },

                                    "id": {
                                        "type": "UInt",
                                        "keyRaw": "id",
                                        "visible": true
                                    }
                                }
                            },

                            "visible": true
                        }
                    }
                },

                "visible": true
            }
        }
    },

    "pluginData": {
        "houdini-svelte": {
            "isManualLoad": true
        }
    },

    "input": {
        "fields": {
            "sku": "Int",
            "storeId": "Int"
        },

        "types": {},
        "defaults": {},
        "runtimeScalars": {}
    },

    "policy": "NetworkOnly",
    "partial": false
};

"HoudiniHash=d50c34c15f053d1099251713c42f28af482885833f00cb2705d7204d73fbe922";